export const configAxios = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
